var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "absolute left-1/4 max-w-md top-40 pb-6 -mt-3 z-10 rounded-md shadow-lg bg-white focus:outline-none",
      attrs: {
        role: "menu",
        "aria-orientation": "vertical",
        "aria-labelledby": "menu-button",
        tabindex: "-1",
      },
    },
    [
      _c("div", [
        _c("div", [
          _c("a", { staticClass: "flex", attrs: { href: "#" } }, [
            _c("img", {
              staticClass: "mx-auto h-6 w-auto mr-5 mt-5",
              attrs: {
                src: require("@/assets/Close.svg"),
                alt: "close filter",
              },
              on: { click: _vm.closeModal },
            }),
          ]),
        ]),
        _c("div", { staticClass: "button-move mr-96 px-6 py-1" }),
        _c(
          "div",
          { staticClass: "flex pl-6 -pt-6" },
          [
            _vm.avatar
              ? [
                  _vm._t(
                    "image",
                    function () {
                      return [
                        _c("S3Image", {
                          class: [
                            _vm.defaultImageClasses,
                            _vm.avatarStyleClasses,
                          ],
                          attrs: { s3FileKey: _vm.avatar },
                        }),
                      ]
                    },
                    {
                      defaultClasses: [
                        _vm.defaultImageClasses,
                        _vm.avatarStyleClasses,
                      ],
                      image: _vm.avatar,
                    }
                  ),
                ]
              : [
                  _vm._t(
                    "initial",
                    function () {
                      return [
                        _c(
                          "span",
                          {
                            class: [
                              _vm.defaultInitialsClasses,
                              _vm.avatarStyleClasses,
                            ],
                            style: _vm.bgStyle,
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "text-sm leading-none text-white",
                              },
                              [_vm._v(_vm._s(_vm.initial) + " ")]
                            ),
                          ]
                        ),
                      ]
                    },
                    {
                      defaultClasses: [
                        _vm.defaultInitialsClasses,
                        _vm.avatarStyleClasses,
                      ],
                    }
                  ),
                ],
            _c("div", [
              _c("p", { staticClass: "ml-1 font-bold" }, [
                _vm._v(" " + _vm._s(_vm.name) + " " + _vm._s(_vm.surname)),
              ]),
              _c("p", { staticClass: "ml-1 text-xs text-gray-500" }, [
                _vm._v(
                  " " + _vm._s(_vm.getFormattedDate(_vm.created_at)) + " "
                ),
              ]),
            ]),
          ],
          2
        ),
      ]),
      _c("p", { staticClass: "px-5 mt-8" }, [
        _vm._v(" " + _vm._s(_vm.notes) + " "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }